import { Injectable } from '@angular/core';

import { TwoFactorChallenge } from 'core/models';

@Injectable({
    providedIn: 'root',
})
export class TwoFactorStorageService {
    public static storageKey = 'twoFactorChallenge';

    public getValue(): TwoFactorChallenge | null {
        const raw = sessionStorage.getItem(TwoFactorStorageService.storageKey);

        if (!raw) {
            return null;
        }

        try {
            return JSON.parse(raw) as TwoFactorChallenge;
        } catch {
            return null;
        }
    }

    public setValue(challenge: TwoFactorChallenge): void {
        sessionStorage.setItem(TwoFactorStorageService.storageKey, JSON.stringify(challenge));
    }

    public removeValue(): void {
        sessionStorage.removeItem(TwoFactorStorageService.storageKey);
    }
}
